(function () {
  'use strict';
  if (window.Kashida) return;

  var TATWEEL = 'ـ';
  var MAX_PER_SLOT = 12;
  var MIN_LETTERS = 3;
  var DUAL = 'بتثجحخسشصضطظعغفقكلمنهيئىپچکگیـ';
  var ALEFS = 'اأإآٱ';
  var MARKS = /[ً-ٰٟۖ-ۭ]/;
  var LETTER = /[ؠ-يٮ-ۓۺ-ۿ]/;
  var STRIP = /[ً-ٰٟـ]/g;

  var originals = new Map();
  var roots = new Map();
  var AUTO = '.rte:not([data-kashida]), .pbuy__h1, .bitem__title, .bitem__note, .c-step__text, [data-kashida-auto]';

  function isMark(ch) { return MARKS.test(ch); }
  function isLetter(ch) { return LETTER.test(ch) && !isMark(ch); }

  function slotsFor(word) {
    var plain = word.replace(STRIP, '');
    if (plain.indexOf('لله') !== -1) return [];
    if (/[A-Za-z0-9٠-٩۰-۹]/.test(word)) return [];
    var slots = [];
    for (var i = 1; i < word.length; i++) {
      var next = word[i];
      if (!isLetter(next)) continue;
      var j = i - 1;
      while (j >= 0 && isMark(word[j])) j--;
      if (j < 0) continue;
      var prev = word[j];
      if (DUAL.indexOf(prev) === -1) continue;
      if (prev === 'ل' && ALEFS.indexOf(next) !== -1) continue;
      slots.push(i);
    }
    return slots.reverse();
  }

  function wrapWords(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (!node.nodeValue.trim()) return;
      var parts = node.nodeValue.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var s = document.createElement('span');
        s.className = 'kw';
        s.textContent = part;
        frag.appendChild(s);
      });
      node.parentNode.replaceChild(frag, node);
    });
    return Array.prototype.slice.call(el.querySelectorAll('span.kw'));
  }

  function measureTatweel(el) {
    var probe = document.createElement('span');
    probe.textContent = 'ببب' + new Array(11).join(TATWEEL) + 'ببب';
    probe.style.whiteSpace = 'nowrap';
    var ref = document.createElement('span');
    ref.textContent = 'بببببب';
    ref.style.whiteSpace = 'nowrap';
    el.appendChild(probe); el.appendChild(ref);
    var w = (probe.getBoundingClientRect().width - ref.getBoundingClientRect().width) / 10;
    el.removeChild(probe); el.removeChild(ref);
    return w > 0.5 ? w : 0;
  }

  function groupLines(words) {
    var lines = [];
    var current = null;
    var top = null;
    words.forEach(function (w) {
      var r = w.getBoundingClientRect();
      if (top === null || Math.abs(r.top - top) > r.height / 2) {
        current = [];
        lines.push(current);
        top = r.top;
      }
      current.push(w);
    });
    return lines;
  }

  function lineWidth(line) {
    var left = Infinity, right = -Infinity;
    line.forEach(function (w) {
      var r = w.getBoundingClientRect();
      if (r.left < left) left = r.left;
      if (r.right > right) right = r.right;
    });
    return right - left;
  }

  function sameLine(line) {
    var a = line[0].getBoundingClientRect();
    var b = line[line.length - 1].getBoundingClientRect();
    return Math.abs(a.top - b.top) < a.height / 2;
  }

  function render(word) {
    var text = word._base;
    var counts = word._counts;
    var out = '';
    for (var i = 0; i < text.length; i++) {
      if (counts[i]) out += new Array(counts[i] + 1).join(TATWEEL);
      out += text[i];
    }
    word.textContent = out;
  }

  function restore(el) {
    if (!originals.has(el)) return;
    el.innerHTML = originals.get(el);
    el.style.textAlign = '';
    el.style.textAlignLast = '';
    el.style.textWrap = '';
    el.removeAttribute('data-kashida-done');
  }

  function justifyParagraph(el) {
    if (!originals.has(el)) originals.set(el, el.innerHTML);
    else el.innerHTML = originals.get(el);

    var last = el.getAttribute('data-kashida-last') || 'right';
    el.style.textAlign = last;
    el.style.textAlignLast = last;
    el.style.textWrap = 'wrap';

    var words = wrapWords(el);
    if (words.length < 3) { el.style.textAlign = ''; el.style.textAlignLast = ''; return; }

    var tw = measureTatweel(el);
    if (!tw) { el.style.textAlign = 'justify'; el.style.textAlignLast = last; return; }

    var style = getComputedStyle(el);
    var available = el.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    var lines = groupLines(words);

    for (var li = 0; li < lines.length - 1; li++) {
      var line = lines[li];
      if (line.length < 2) continue;
      var need = Math.floor((available - lineWidth(line) - 1) / tw);
      if (need <= 0) continue;

      var pool = [];
      line.forEach(function (w) {
        w._base = w.textContent;
        w._counts = {};
        var letters = w._base.replace(/[^ؠ-يٮ-ۓۺ-ۿ]/g, '').length;
        if (letters < MIN_LETTERS) return;
        var s = slotsFor(w._base);
        if (s.length) pool.push({ word: w, slots: s, letters: letters });
      });
      if (!pool.length) continue;
      pool.sort(function (a, b) { return b.letters - a.letters; });

      var placed = 0;
      var maxLevel = 0;
      pool.forEach(function (it) { if (it.slots.length > maxLevel) maxLevel = it.slots.length; });
      for (var level = 0; level < maxLevel && placed < need; level++) {
        var progress = true;
        while (placed < need && progress) {
          progress = false;
          for (var p = 0; p < pool.length && placed < need; p++) {
            var item = pool[p];
            if (level >= item.slots.length) continue;
            var slot = item.slots[level];
            var c = item.word._counts[slot] || 0;
            if (c >= MAX_PER_SLOT) continue;
            item.word._counts[slot] = c + 1;
            placed++;
            progress = true;
          }
        }
      }
      pool.forEach(function (item) { render(item.word); });

      var guard = 0;
      while (!sameLine(line) && guard < 200) {
        guard++;
        var removed = false;
        for (var q = pool.length - 1; q >= 0 && !removed; q--) {
          var counts = pool[q].word._counts;
          for (var k in counts) {
            if (counts[k] > 0) { counts[k]--; render(pool[q].word); removed = true; break; }
          }
        }
        if (!removed) break;
      }
    }

    el.style.textAlign = 'justify';
    el.style.textAlignLast = last;
    el.setAttribute('data-kashida-done', '');
  }

  function targetsOf(body) {
    if (body.matches('p, li, blockquote, h1, h2, h3, h4, h5, h6')) return [body];
    return Array.prototype.filter.call(body.querySelectorAll('p, li, blockquote'), function (el) {
      if (el.closest('.rcallout__title, table, figure, .inline-product')) return false;
      if (el.querySelector('p, li, blockquote, img, iframe, table, ul, ol')) return false;
      return true;
    });
  }

  function run() {
    roots.forEach(function (_, root) {
      if (!root.isConnected) { roots.delete(root); return; }
      if (!root.offsetParent && getComputedStyle(root).position !== 'fixed') return;
      targetsOf(root).forEach(justifyParagraph);
      roots.set(root, root.clientWidth);
    });
    document.dispatchEvent(new CustomEvent('kashida:done'));
  }

  function schedule() {
    if (!roots.size) return;
    if (schedule._t) cancelAnimationFrame(schedule._t);
    schedule._t = requestAnimationFrame(function () { requestAnimationFrame(run); });
  }

  var Kashida = {
    apply: function (body) {
      roots.set(body, 0);
      watch(body);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule); else schedule();
    },
    clear: function (body) {
      roots.delete(body);
      if (ro) ro.unobserve(body);
      originals.forEach(function (_, el) { if (body.contains(el)) { restore(el); originals.delete(el); } });
      document.dispatchEvent(new CustomEvent('kashida:done'));
    },
    refresh: schedule,
    slotsFor: slotsFor
  };
  window.Kashida = Kashida;

  var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
    var changed = false;
    entries.forEach(function (en) {
      var root = en.target;
      if (!roots.has(root)) return;
      if (Math.abs(root.clientWidth - roots.get(root)) > 1) changed = true;
    });
    if (changed) schedule();
  }) : null;
  function watch(el) { if (ro) ro.observe(el); }
  window.addEventListener('load', function () { schedule(); });

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () {
      var changed = false;
      roots.forEach(function (w, root) { if (Math.abs(root.clientWidth - w) > 1) changed = true; });
      if (changed) schedule();
    }, 150);
  });
  document.addEventListener('reader:scale', schedule);

  document.addEventListener('copy', function (e) {
    var sel = window.getSelection();
    if (!sel || !sel.rangeCount) return;
    var node = sel.anchorNode && (sel.anchorNode.nodeType === 1 ? sel.anchorNode : sel.anchorNode.parentNode);
    if (!node || !node.closest || !node.closest('[data-kashida], [data-kashida-done]')) return;
    var text = sel.toString().replace(/ـ/g, '');
    if (e.clipboardData) { e.clipboardData.setData('text/plain', text); e.preventDefault(); }
  });

  function auto(scope) {
    var found = false;
    (scope || document).querySelectorAll(AUTO).forEach(function (el) {
      if (el.closest('[data-kashida], .rtools, [data-no-kashida], [contenteditable]')) return;
      if (roots.has(el)) return;
      if (!el.hasAttribute('data-kashida-last') && getComputedStyle(el).textAlign === 'center') return;
      roots.set(el, 0); watch(el); found = true;
    });
    if (found) { if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule); else schedule(); }
  }
  Kashida.auto = auto;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { auto(); }); else auto();
  document.addEventListener('shopify:section:load', function (e) { auto(e.target); });
  var mt = 0;
  if (window.MutationObserver) new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) if (list[i].addedNodes.length) { clearTimeout(mt); mt = setTimeout(function () { auto(); }, 120); return; }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('toggle', schedule, true);

  document.dispatchEvent(new CustomEvent('kashida:ready'));
})();
